import React, { useState } from "react";
import styled from "styled-components";
import ImagePreviewModal from "@components/ImagePreviewModal";

const StyledBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px; // 'gap' property can be used to set spacing between grid items
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 15px;
`;

const StyledImage = styled.img`
  cursor: pointer;
  width: 30%;
  height: 10vh;
  border-radius: 5px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  &:hover {
    // Add any hover effects you want here
  }
`;

function Images({ images }) {
  const [openPreviewImage, setOpenPreviewImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpenPreviewImage = (src) => {
    setSelectedImage(src);
    setOpenPreviewImage(true);
  };

  const handleClosePreviewImage = () => {
    setOpenPreviewImage(false);
  };

  return (
    <>
      <StyledBox>
        {images.map((e, index) => (
          <StyledImage
            alt="Alt of img"
            src={e}
            onClick={() => handleOpenPreviewImage(e)}
            style={{
              marginRight: "5px",
              backgroundImage: `url(${e})`,
            }}
          />
        ))}
      </StyledBox>
      <ImagePreviewModal
        openPreviewImage={openPreviewImage}
        handleClosePreviewImage={handleClosePreviewImage}
        selectedImage={selectedImage}
        customModalStyle={{
          width: "95vw",
          height: "50vh",
        }}
      />
    </>
  );
}

export default Images;
